import PractitionerNotes from './PractitionerNotes';

export default PractitionerNotes;
